import type { VisibilityState } from '@tanstack/react-table';
import type { AnyColumnDef } from './Any';
import type { TableState } from './TableState';
import { getColumnId } from './getColumnId';
import type z from 'zod';

export const getDefaultValues = (columns: AnyColumnDef[], schema: z.ZodSchema): TableState =>
  schema.parse({
    visibility: getVisibility(columns),
  });

const getVisibility = (columns: AnyColumnDef[]): VisibilityState =>
  columns.filter(isColumnHidden).reduce((acc: VisibilityState, column) => {
    acc[getColumnId(column)] = false;
    return acc;
  }, {} as VisibilityState);

const isColumnHidden = (column: AnyColumnDef): column is AnyColumnDef & { meta: { isHidden: boolean } } =>
  column.meta?.isHidden === true;
